var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.36397 18.6777L10.7279 12.3137L4.36397 5.94975L5.77819 4.53553L13.5564 12.3137L5.77819 20.0919L4.36397 18.6777ZM11.435 18.6777L17.799 12.3137L11.435 5.94975L12.8493 4.53553L20.6274 12.3137L12.8493 20.0919L11.435 18.6777Z",
    fill: "#11100C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIconBlack);
export default __webpack_public_path__ + "static/media/right-icon-black.55a62f37b10b548cd42cebf007275600.svg";
export { ForwardRef as ReactComponent };